const List = r => require.ensure([], () => r(require('@/views/task/list')), '@/views/task/..')
const TaskHelp = r => require.ensure([], () => r(require('@/views/task/help')), '@/views/task/..')
const TaskHelpTable = r => require.ensure([], () => r(require('@/views/task/help-table')), '@/views/task/..')
const TaskListTable = r => require.ensure([], () => r(require('@/views/task/list-table')), '@/views/task/..')
const tpl = {
    template: '<router-view></router-view>'
}

export default [
    {
        path: '',
        redirect: 'list'
    },
    {
        path: 'list',
        component: List,
        children: [
            {
                path: ':type?',
                component: TaskListTable,
                meta: {
                    title: '我的任务'
                }
            }
        ]
    },
    {
        path: 'help',
        component: tpl,
        children: [
            {
                path: ':module',
                component: TaskHelp,
                children: [
                    {
                        path: ':type?',
                        component: TaskHelpTable,
                        beforeEnter: (to, from, next) => {
                            if (to.params.module === 'coins') {
                                document.title = '如何赚取金币'
                            } else if (to.params.module === 'growth') {
                                document.title = '如何获取成长值'
                            }
                            next()
                        }
                    }
                ]
            }
        ]
    }
]



// WEBPACK FOOTER //
// ./src/router/task.js